import type { PayloadAction } from "@reduxjs/toolkit"
import { createAppSlice } from "@/app/createAppSlice"

export type LayoutState = {
  viewportHeight: number
  isFullscreenMode: boolean
}

const initialState: LayoutState = {
  viewportHeight: 0,
  isFullscreenMode: false,
}

export const layoutSlice = createAppSlice({
  name: "layout",
  initialState,
  reducers: create => ({
    setViewportHeight: create.reducer(
      (state, action: PayloadAction<number>) => {
        state.viewportHeight = action.payload
      },
    ),
    setFullscreenMode: create.reducer(
      (state, action: PayloadAction<boolean>) => {
        state.isFullscreenMode = action.payload
      },
    ),
  }),
  selectors: {
    selectViewportHeight: layout => layout.viewportHeight,
    selectIsFullscreenMode: layout => layout.isFullscreenMode,
  },
})

export const { setViewportHeight, setFullscreenMode } = layoutSlice.actions
export const { selectViewportHeight, selectIsFullscreenMode } =
  layoutSlice.selectors
